export default "__VITE_ASSET__zh88wvDg__"